/**
 * On-chain pause flags from FraxlendPair (see `isInterestPaused`, etc.).
 * Deposit/borrow pauses are toggled via `pauseDeposit` / `pauseBorrow` but
 * standard Fraxlend does not expose matching view getters in our ABI.
 */
export interface FraxlendPairPauseState {
  interestPaused: boolean
  liquidatePaused: boolean
  repayPaused: boolean
  withdrawPaused: boolean
}

export function hasAnyFraxlendPause(state: FraxlendPairPauseState): boolean {
  return state.interestPaused || state.liquidatePaused || state.repayPaused || state.withdrawPaused
}
